import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["profile", "accruedPoints", "closeChallengePlayer", "isOnboarding", "enterButtonToggle", "showAnimation", "handleDisableAnimation", "stageCompletions"],
    _excluded2 = ["currentChallengeId", "completeStageStatus", "stageCompletions"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Confetti, EnterHubButton, useTrackOnboardingChallengeCompleted } from '@infl-ts/ui-advocate-components';
import { CoinsIcon } from '@infl-ts/ui-advocate-icons';
import { useToggle } from '@infl-ts/util-hooks';
import { PublicResponseStageNames, useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import { Box, Button, Typography } from '@mui/material';
import * as A from 'fp-ts/Array';
import { constant, constNull, flow, pipe } from 'fp-ts/function';
import * as Num from 'fp-ts/number';
import * as O from 'fp-ts/Option';
import * as Ord from 'fp-ts/Ord';
import CountUp from 'react-countup';
import { Translation } from 'react-i18next';
import TabbedPublicResponses from './public-responses';
import RecommendedChallenges from './recommended-challenges';
import useRecommendedChallenges from './use-recommended-challenges';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var formatPoints = function formatPoints(points) {
  return points.toLocaleString();
};

var nonNegative = Ord.clamp(Num.Ord)(0, Infinity);

var hasPublicResponseStages = function hasPublicResponseStages(stages) {
  return pipe(stages, A.some(function (stage) {
    return PublicResponseStageNames.is(stage.__typename);
  }));
};

export var PureCompletionScreen = function PureCompletionScreen(_ref) {
  var profile = _ref.profile,
      accruedPoints = _ref.accruedPoints,
      closeChallengePlayer = _ref.closeChallengePlayer,
      isOnboarding = _ref.isOnboarding,
      _ref$enterButtonToggl = _slicedToArray(_ref.enterButtonToggle, 2),
      enterButtonShown = _ref$enterButtonToggl[0],
      showEnterButton = _ref$enterButtonToggl[1].on,
      showAnimation = _ref.showAnimation,
      handleDisableAnimation = _ref.handleDisableAnimation,
      stageCompletions = _ref.stageCompletions,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "PureCompletionScreen",
    "data-source-file": "index.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: 1
        },
        children: [showAnimation && /*#__PURE__*/_jsx(Confetti, {}), /*#__PURE__*/_jsx(Typography, {
          variant: "h2",
          sx: {
            zIndex: function zIndex(t) {
              return t.zIndex._3;
            }
          },
          children: t('Challenge Completed')
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          sx: {
            mt: 4,
            zIndex: function zIndex(t) {
              return t.zIndex._3;
            }
          },
          children: t('Current points')
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            mt: 2,
            mb: 6,
            zIndex: function zIndex(t) {
              return t.zIndex._3;
            }
          },
          children: /*#__PURE__*/_jsxs(Typography, {
            sx: {
              display: 'flex',
              alignItems: 'center'
            },
            variant: "h1",
            children: [/*#__PURE__*/_jsx(CoinsIcon, {
              sx: {
                height: 40,
                width: 40
              }
            }), /*#__PURE__*/_jsx(CountUp, {
              preserveValue: true,
              start: showAnimation ? nonNegative(profile.currentPoints - accruedPoints) : profile.currentPoints,
              end: profile.currentPoints,
              duration: 1.5,
              formattingFn: formatPoints,
              onEnd: function onEnd() {
                showEnterButton();
                handleDisableAnimation();
              }
            })]
          })
        }), isOnboarding ? enterButtonShown && /*#__PURE__*/_jsx(EnterHubButton, {
          closeChallengePlayer: closeChallengePlayer
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(RecommendedChallenges, _objectSpread({}, props)), /*#__PURE__*/_jsx(Button, {
            variant: "contained",
            color: "secondary",
            disableElevation: true,
            sx: {
              mt: 4
            },
            onClick: closeChallengePlayer,
            children: t('Close')
          })]
        }), pipe(stageCompletions, O.map(A.map(function (sc) {
          return sc.stage;
        })), O.chain(O.fromPredicate(hasPublicResponseStages)), O.chain(flow(A.filter(function (stage) {
          var _stage$publicResponse, _stage$publicResponse2;

          return stage.responsesArePublic && ((_stage$publicResponse = (_stage$publicResponse2 = stage.publicResponses) === null || _stage$publicResponse2 === void 0 ? void 0 : _stage$publicResponse2.totalCount) !== null && _stage$publicResponse !== void 0 ? _stage$publicResponse : 0) > 0;
        }), A.match(constant(O.none), O.some))), O.match(constNull, function (stages) {
          return /*#__PURE__*/_jsx(TabbedPublicResponses, {
            stages: stages,
            profile: profile
          });
        }))]
      });
    }
  });
};

var useProps = function useProps(_ref2) {
  var currentChallengeId = _ref2.currentChallengeId,
      completeStageStatus = _ref2.completeStageStatus,
      stageCompletions = _ref2.stageCompletions,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var _useChallengePlayer = useChallengePlayer(),
      closeChallengePlayer = _useChallengePlayer.closeChallengePlayer;

  var _useRecommendedChalle = useRecommendedChallenges({
    challengeId: currentChallengeId,
    completeStageStatus: completeStageStatus
  }),
      recommendedChallenges = _useRecommendedChalle.recommendedChallenges,
      fetchMoreUnlocked = _useRecommendedChalle.fetchMoreUnlocked;

  useTrackOnboardingChallengeCompleted({
    skip: !props.isOnboarding
  });
  return _objectSpread({
    challenges: recommendedChallenges,
    closeChallengePlayer: closeChallengePlayer,
    enterButtonToggle: useToggle(),
    handleFetchMore: fetchMoreUnlocked,
    stageCompletions: stageCompletions
  }, props);
};

export default Object.assign(flow(useProps, PureCompletionScreen), {
  displayName: 'CompletionScreen'
});